/**
 * Presentation for a data quality category, keyed by the category key the server sends.
 * An unknown key has no entry - callers fall back to a neutral style rather than guessing
 * a colour, so a category the client does not know about never renders as a wrong verdict.
 */
export interface QualityCategoryStyle {
    badge: string;
    dot: string;
    text: string;
    chart: string;
}

export const QUALITY_CATEGORY_STYLES: Record<string, QualityCategoryStyle> = {
    Excellent: { badge: 'bg-green-100 text-green-700', dot: 'bg-green-500', text: 'text-green-700', chart: '#16a34a' },
    Uncertain: { badge: 'bg-yellow-100 text-yellow-700', dot: 'bg-yellow-500', text: 'text-yellow-700', chart: '#ca8a04' },
    Inferior: { badge: 'bg-red-100 text-red-700', dot: 'bg-red-500', text: 'text-red-700', chart: '#ef4444' },
};
